/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdemployee_Goethe16Inputs */

const en__field_enum_sdemployee_goethe16 = /** @type {(inputs: _Field_Enum_Sdemployee_Goethe16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angestellte/r Goethe Universität`)
};

const de__field_enum_sdemployee_goethe16 = /** @type {(inputs: _Field_Enum_Sdemployee_Goethe16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angestellte/r Goethe Universität`)
};

/**
* | output |
* | --- |
* | "Angestellte/r Goethe Universität" |
*
* @param {_Field_Enum_Sdemployee_Goethe16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdemployee_goethe16 = /** @type {((inputs?: _Field_Enum_Sdemployee_Goethe16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdemployee_Goethe16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdemployee_goethe16(inputs)
	return de__field_enum_sdemployee_goethe16(inputs)
});
export { _field_enum_sdemployee_goethe16 as "_field_enum_SDEMPLOYEE_GOETHE" }